//import Botd from '@fpjs-incubator/botd-agent';


var rc = document.createElement('script'),
  lang = document.documentElement.lang.replace(/([^-]+).*/, '$1');

rc.type = 'text/javascript';
rc.src = `https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=6Lc6acYUAAAAAF7wfeeoBTwrMxOmfb-xiGgc8qFS&lang=${lang}&hl=${lang}`;

document.body.appendChild(rc);

//const botdPromise = Botd.load({publicKey: "YKSe6qzBPkfcBtFSeRkmoDyE"})

window.recaptchaCallback = function () {
  grecaptcha.ready(function () {
    //grecaptcha.execute('6Lc6acYUAAAAAF7wfeeoBTwrMxOmfb-xiGgc8qFS', {action: 'initial'});

    let submitting = false,
      forms = document.querySelectorAll('form.secure-submit');

    for (var i = 0; i < forms.length; i++) {
      let recaptchav2 = forms[i].querySelector('.g-recaptcha'),
        v2widget = null,
        v2element = forms[i].querySelector('.rcap-resp-vb');

      if (recaptchav2) {
        v2widget = grecaptcha.render(recaptchav2, {
          'sitekey': '6Le5NVsqAAAAAJ-Tsk7KhPM83GkVmUtH1jXl0UHP'
        });
      }

      forms[i].addEventListener('submit', function (e) {
        if (submitting) {
          return;
        }

        submitting = true;

        let $this = this;
        e.preventDefault();

        $this.className += ' requested';

        if (v2widget !== null) {
          let v2response = grecaptcha.getResponse(v2widget);
          if (!v2response) {
            $this.classList.remove('requested');
            return;
          }

          v2element.value = v2response;
        }

        grecaptcha.execute('6Lc6acYUAAAAAF7wfeeoBTwrMxOmfb-xiGgc8qFS', {action: 'form_submit'}).then(function (token) {
          var responseElement = document.createElement('input');

          responseElement.name = 'g-recaptcha-response';
          responseElement.type = 'hidden';
          responseElement.value = token;

          $this.appendChild(responseElement);

          $this.submit();
        })/*.then(function () {
            botdPromise
              .then(botd => botd.detect())
              .then(result => {
                var responseElement = document.createElement('input');

                responseElement.name = 'botd-request';
                responseElement.type = 'hidden';
                responseElement.value = result.requestId;

                $this.appendChild(responseElement);

                submitting = false;

                $this.submit()
              })
              .catch(error => $this.submit())
          })*/.catch(function () {
          $this.submit();
        });
      }, false);
    }
  });
}
